module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-hover-bg-right.89bea18a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-hover-bg-right.png
// module id = 3488
// module chunks = 11